<template>
  <p v-html="sloganx">{{$t(`${sloganx}`)}}</p>
</template>

<script>
export default {
  props: {
    sloganx: { type: String, required: true },
  },
};
</script>

<style scoped>

</style>